import { render, staticRenderFns } from "./PrizesSettings.vue?vue&type=template&id=e527370a&"
import script from "./PrizesSettings.vue?vue&type=script&lang=js&"
export * from "./PrizesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports